import type { ExperienceItem } from '@/types/abtest'

type TrackOptions = {
  /**
   * Optional array of experience keys. For each key, pushCurrentVisitorExperimentToDataLayer
   * is called so the current visitor's experiment data is sent to the data layer.
   */
  experienceKeys?: string[]
}

export const useConvert = () => {
  const route = useRoute()
  const { pushCurrentVisitorExperimentToDataLayer } = useConvertExperiments()
  const variationsCookie = useCookie<ExperienceItem[]>('ota-conv-ab')

  const track = async (options: TrackOptions = {}): Promise<ExperienceItem[] | null> => {
    const experienceKeys = options.experienceKeys ?? []

    if (!experienceKeys.length) {
      return null
    }

    const variations = variationsCookie.value || []
    const matchedVariations = variations.filter((v) => experienceKeys.includes(v.experienceKey))

    if (!matchedVariations.length) {
      return null
    }

    await Promise.all(
      matchedVariations.map((variation) =>
        $fetch('/nuxt-api/convert/track', {
          method: 'POST',
          body: { variation }
        }).catch((error) => {
          logError(error)
        })
      )
    )

    for (const { experienceKey } of matchedVariations) {
      pushCurrentVisitorExperimentToDataLayer(experienceKey)
    }

    return matchedVariations
  }

  const refreshConvertVariations = async () => {
    try {
      await $fetch('/nuxt-api/convert/refresh', {
        method: 'POST',
        body: {
          pathname: route.path
        }
      })
    } catch (error) {
      logError(error)
    }
  }

  return {
    track,
    refreshConvertVariations
  }
}
